
module.cC({
    name: 'InlineFormController',

    inject: ['$scope', '$attrs', '$element', '$timeout', '$parse',
             'FormService', 'Page'],

    data: {
        state: '{editing: false}',
        focusers: '{}',
        firstFocuser: false,
        forms: '[]',
    },

    init: function() {
        var inlineFormName = this.$parse(this.$attrs.inlineFormName);

        if (angular.isDefined(inlineFormName.assign)) {
            inlineFormName.assign(this.$.$parent, this);
        }
        this.$.inlineForm = this;

        if (angular.isDefined(this.$attrs.canEdit)) {
            this._initCanEdit();
        } else {
            this.canEdit = true;
        }
    },

    on: {
        '$destroy': function() {
            this.FormService.removeForm(this.name);
        }
    },

    methods: {

        registerFocusHandler: function(name, handler) {
            this.focusers[name] =  handler;
            this.firstFocuser = this.firstFocuser || this.focusers[name];
        },

        scrollAndFocus: function(name) {
            var focuser = this.focusers[name] || this.firstFocuser || angular.noop;
            var element = focuser();
            element = angular.isDefined(element) ? element : this.$element;
            if (element) {
                this.$timeout(this.Page.scrollTo.bind(this.Page, element));
            }
        },

        setOpenData: function(data) {
            for (var i = 0; i < this.forms.length; i++) {
                this.forms[i].setOpenData(data);
            }
        },

        toggle: function() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },

        open: function(name, data) {
            if (!this.canEdit) {
                return
            }
            this.$element.addClass('editing');
            this.isOpen = true;
            this.state.editing = true;
            this.$timeout(this.setOpenData.bind(this, data), 10);
            this.$timeout(this.scrollAndFocus.bind(this, name), 10);
            if (!this.$attrs.noIntercept) {
                this.$scope.$emit('formEvent', this.name, 'open');
            }
        },

        close: function() {
            this.Page.scrollTo(this.$element);
            this.$element.removeClass('editing');
            this.state.editing = false;
            this.isOpen = false;
            this.$scope.$emit('formEvent', this.name, 'close');
        },

        isDirty: function() {
            for (var i = 0; i < this.forms.length; i++) {
                if (this.forms[i].isDirty()) {
                    return true;
                }
            }
            return false;
        },

        addFormController: function(form) {
            var index = this.forms.indexOf(form);
            if (index === -1) {
                this.forms.push(form);
            }
        },

        removeFormController: function(form) {
            var index = this.forms.indexOf(form);
            if (index >= 0) {
                this.forms.splice(index, 1);
            }
            this.firstFocuser = false;
        },

        _registerForm: function() {
            this.FormService.addForm(this.name, this);
        },

        _initCanEdit: function() {
            this.$.$watch(this.$attrs.canEdit, this._setCanEdit);
        },

        _setCanEdit: function(canEdit) {
            this.canEdit = canEdit;
            this.$element.toggleClass('no-edit', !canEdit);

            if (!canEdit && this.isOpen) {
                this.close();
            }
        },
    }
});

module.directive('inlineForm', function() {
    return {
        restrict: 'E',
        require: 'inlineForm',
        scope: true,

        link: function(scope, element, attrs, inlineForm) {
            inlineForm.name = attrs.name || ("form_" + scope.$id);
            inlineForm._registerForm();
        },

        controller: 'InlineFormController',
    };
});


module.directive('inlineFormView', function() {
    return {
        restrict: 'E',
        transclude: true,
        templateUrl: "util/forms/inlineFormView",
        require: '^inlineForm',
        link: function(scope, element, attrs, inlineForm) {
            scope.container = inlineForm;
        }
    };
});


module.directive('inlineFormEdit', function() {
    return {
        restrict: 'E',
        transclude: true,
        templateUrl: "util/forms/inlineFormEdit",
        require: '^inlineForm',
        link: function(scope, element, attrs, inlineForm) {
            scope.container = inlineForm;
        }
    };
});